import { render, staticRenderFns } from "./BoardShimmer.vue?vue&type=template&id=fb98be32&"
import script from "./BoardShimmer.vue?vue&type=script&lang=js&"
export * from "./BoardShimmer.vue?vue&type=script&lang=js&"
import style0 from "./BoardShimmer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports